import * as React from "react";

function SvgChameleon(props, ref) {
  return (
    <svg viewBox="0 0 23.7 36" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        d="M15.5 21.4C28.3 15.3 22.3 0 22.3 0-3.6 0 .2 22.4.2 22.4h14.1c2.3 1.2 5 5.4 2.1 9.1-1.5 1.9-4.4 2.1-6.2.5-.7-.7-2.3-2.9-.5-5.3 1.3-1.8 3.8-1.1 4.6-.3.3.3.4.8.1 1.2-.3.3-.8.4-1.1.1-.3-.3-1.3-.7-2.1.2-.4.4-1 1.8.2 3 1.1 1.1 3 .9 4-.3 1.8-2.3.4-4.6-.4-5.3-2-1.8-5-1.4-6.8.5C6.6 27.5 6.8 30 7 30.7c.9 3.9 4.9 6.3 8.7 5.1 6.7-2.2 9.2-11.2 6.7-17.8-1.9 2-4.3 3.2-6.9 3.4zM7 16.6c-2.1-2.9-1.4-7 1.4-9.1 2.8-2.1 6.8-1.5 8.8 1.4s1.4 7-1.4 9.1C13 20.2 9 19.5 7 16.6zm2.8-1.1c.5.7 1.5.9 2.2.4.7-.5.9-1.5.4-2.2-.5-.7-1.5-.9-2.2-.4-.8.5-.9 1.5-.4 2.2z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#94c952"
      />
    </svg>
  );
}

export default React.forwardRef(SvgChameleon);
